/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-04-29 18:43:42
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-07-15 16:26:05
 * @FilePath: /designcenter/src/utils/modules/commom.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { uploadFileService } from '@/api'
import { FS_DOMAIN } from './const'
import { Cookie } from './cookie'
import dayjs from 'dayjs'

export function formatTime(time: string, format = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs(time).format(format)
}

// 上传文件，传项目id和file对象
export async function uploadFile(projectId: number, file: File): Promise<string | unknown> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('projectId', projectId.toString())
  const res = await uploadFileService(formData)
  return res
}

//处理FS链接
export const handleFsLink = (link: string) => {
  console.log('handle_link')
  console.log(FS_DOMAIN)
  return `${FS_DOMAIN}${link}`
}

/**
 * 解析当前页面 URL 的 query 参数为对象
 * 支持处理 HTML 实体编码（如 &amp;）和特殊字符
 * @param url - 可选，指定要解析的 URL，默认使用当前页面 URL
 * @returns 包含所有 query 参数键值对的对象
 *
 * @example
 * // URL: design-center?id=1&amp;share=1
 * parseUrlParams() // { id: '1', share: '1' }
 *
 * // URL: design-center?name=hello%20world&id=123
 * parseUrlParams() // { name: 'hello world', id: '123' }
 *
 * // URL: design-center?id=1&amp%3Bshare=1
 * parseUrlParams() // { id: '1', share: '1' }
 */
export const parseUrlParams = (url?: string): { [key: string]: string } => {
  const params: { [key: string]: string } = {}

  try {
    // 获取 URL 字符串
    let searchString = url || window.location.search

    // 如果传入完整 URL，提取 search 部分
    if (url && url.includes('?')) {
      searchString = url.split('?')[1] || ''
    } else if (searchString.startsWith('?')) {
      searchString = searchString.slice(1)
    }

    if (!searchString) {
      return params
    }

    // 先进行 URL 解码（处理 %3B 等 URL 编码）
    // 然后再解码 HTML 实体（处理 &amp; 等 HTML 实体）
    const urlDecoded = decodeURIComponent(searchString)
    const htmlDecoded = decodeHTMLEntities(urlDecoded)

    // 使用 URLSearchParams 解析
    const urlParams = new URLSearchParams(htmlDecoded)

    // 转换为普通对象
    urlParams.forEach((value, key) => {
      params[key] = value
    })
  } catch (error) {
    console.error('解析 URL 参数失败:', error)
    // 如果解码失败，尝试降级处理
    try {
      let searchString = url || window.location.search
      if (url && url.includes('?')) {
        searchString = url.split('?')[1] || ''
      } else if (searchString.startsWith('?')) {
        searchString = searchString.slice(1)
      }

      // 只进行 HTML 实体解码
      const htmlDecoded = decodeHTMLEntities(searchString)
      const urlParams = new URLSearchParams(htmlDecoded)
      urlParams.forEach((value, key) => {
        params[key] = value
      })
    } catch (fallbackError) {
      console.error('降级解析也失败:', fallbackError)
    }
  }

  return params
}

/**
 * 解码 HTML 实体
 * @param str - 包含 HTML 实体的字符串
 * @returns 解码后的字符串
 */
function decodeHTMLEntities(str: string): string {
  // 使用 textarea 安全地解码 HTML 实体，避免 XSS 风险
  // textarea 不会执行脚本，比 DOMParser 更安全
  const textarea = document.createElement('textarea')
  textarea.innerHTML = str
  return textarea.value
}

/**
 * 安全地获取 URL 参数值
 * @param key - 参数名
 * @param defaultValue - 默认值
 * @param url - 可选，指定要解析的 URL
 * @returns 参数值或默认值
 *
 * @example
 * // URL: design-center?id=1&amp;share=1
 * getUrlParam('id') // '1'
 * getUrlParam('share') // '1'
 * getUrlParam('missing', 'default') // 'default'
 */
export const getUrlParam = (key: string, defaultValue: string = '', url?: string): string => {
  const params = parseUrlParams(url)
  return params[key] || defaultValue
}

/**
 * 获取并转换 URL 参数为数字
 * @param key - 参数名
 * @param defaultValue - 默认值
 * @param url - 可选，指定要解析的 URL
 * @returns 参数值（数字）或默认值
 */
export const getUrlParamAsNumber = (key: string, defaultValue: number = 0, url?: string): number => {
  const value = getUrlParam(key, '', url)
  const num = parseInt(value, 10)
  return isNaN(num) ? defaultValue : num
}

/**
 * 获取并转换 URL 参数为布尔值
 * @param key - 参数名
 * @param defaultValue - 默认值
 * @param url - 可选，指定要解析的 URL
 * @returns 参数值（布尔）或默认值
 */
export const getUrlParamAsBoolean = (key: string, defaultValue: boolean = false, url?: string): boolean => {
  const value = getUrlParam(key, '', url)
  if (value === '1' || value.toLowerCase() === 'true') return true
  if (value === '0' || value.toLowerCase() === 'false') return false
  return defaultValue
}

// 全角转半角
export const checkIssbccase = (str: string) => {
  let result = ''
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i)
    if (code >= 65281 && code <= 65374) {
      result += String.fromCharCode(str.charCodeAt(i) - 65248)
    } else if (code == 12288) {
      result += String.fromCharCode(str.charCodeAt(i) - 12288 + 32)
    } else {
      result += str.charAt(i)
    }
  }
  return result
}

/**
 * @param options 轮询选项
 * @returns 返回停止轮询的函数
 */
export function createPolling(options: {
  DISTANCE_TIME: number
  doing: () => Promise<boolean> | boolean
  done?: () => void
  maxAttempts?: number
}) {
  const { DISTANCE_TIME, doing, done, maxAttempts } = options
  let timer: null | ReturnType<typeof setTimeout> = null
  let attempts = 0
  let isRunning = true
  let isStopped = false // 明确标记是否已停止

  const execute = async () => {
    // 如果已被标记为停止或不在运行状态，则不继续执行
    if (isStopped || !isRunning) return

    if (maxAttempts !== undefined && attempts >= maxAttempts) {
      stop()
      done?.()
      return
    }

    attempts++
    try {
      const shouldContinue = await doing()

      // 再次检查停止状态，防止在doing执行过程中被停止
      if (isStopped || !isRunning) return

      if (shouldContinue === false) {
        stop()
        done?.()
        return
      }

      // 确保仍在运行状态
      if (isRunning && !isStopped) {
        timer = setTimeout(execute, DISTANCE_TIME)
      }
    } catch (error) {
      console.error('轮询执行出错:', error)
      // 出错时也继续轮询，除非明确停止
      if (isRunning && !isStopped) {
        timer = setTimeout(execute, DISTANCE_TIME)
      }
    }
  }

  const stop = () => {
    // 明确标记为已停止
    isStopped = true
    isRunning = false

    if (timer) {
      clearTimeout(timer)
      timer = null
    }

    console.log('轮询已停止') // 添加日志确认停止
  }

  // 立即开始执行
  execute()

  // 返回停止函数
  return stop
}

export const imageToBase64 = (url: string) => {
  return new Promise((resolve, reject) => {
    if (!url) {
      resolve('')
      return
    }

    const img = new Image()
    img.crossOrigin = 'anonymous' // 处理跨域
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width || 50
      canvas.height = img.height || 50
      const ctx = canvas.getContext('2d')
      ctx?.drawImage(img, 0, 0)
      const base64 = canvas.toDataURL('image/png')
      resolve(base64)
    }
    img.onerror = () => {
      console.error('图片加载失败:', url)
      reject(new Error(`无法加载图片: ${url}`))
    }
    img.src = url
  })
}

//获取当前路由的参数
export const getRouteParams = (
  route: unknown,
  options: {
    // 是否将数字字符串转换为数字类型
    parseNumber?: boolean
    // 是否将布尔字符串转换为布尔类型
    parseBoolean?: boolean
    // 是否将JSON字符串转换为对象
    parseJSON?: boolean
    // 需要转换的特定字段
    transformFields?: {
      [key: string]: (value: string) => any
    }
  } = {}
) => {
  const { parseNumber = true, parseBoolean = true, parseJSON = true, transformFields = {} } = options

  const query = route.query
  const params: Record<string, any> = {}

  // 遍历查询参数
  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      params[key] = value
      return
    }

    // 如果值是数组，处理数组中的每个元素
    if (Array.isArray(value)) {
      params[key] = value.map(v => parseValue(v, key))
      return
    }

    // 处理单个值
    params[key] = parseValue(value, key)
  })

  // 解析值的辅助函数
  function parseValue(value: string, key: string): unknown {
    // 1. 优先使用自定义转换函数
    if (transformFields[key]) {
      return transformFields[key](value)
    }

    // 2. 尝试解析JSON
    if (parseJSON) {
      try {
        const parsed = JSON.parse(value)
        return parsed
      } catch {
        // 解析失败，继续其他解析
      }
    }

    // 3. 尝试解析数字
    if (parseNumber && /^-?\d+(\.\d+)?$/.test(value)) {
      return Number(value)
    }

    // 4. 尝试解析布尔值
    if (parseBoolean) {
      if (value.toLowerCase() === 'true') return true
      if (value.toLowerCase() === 'false') return false
    }

    // 5. 返回原始字符串
    return value
  }

  return params
}

export const setLoginUrl = () => {
  type StringObject = {
    [key: string]: string
  }

  const url = new URL(window.location.href)
  let newParams: StringObject = {}

  const fs_websiteinfo = Cookie.get('fs_websiteinfo')
  if (fs_websiteinfo) {
    try {
      const parsed = JSON.parse(fs_websiteinfo)
      if (parsed.website && !['cn', 'hk', 'mo', 'tw'].includes(parsed.website)) {
        // newParams = {
        //   country: 'US',
        //   languages: 'English',
        //   currency: 'USD',
        // }
      }
    } catch (error: unknown) {
      console.error('JSON 解析错误:', error.message)
    }
  } else {
    // newParams = {
    //   country: 'US',
    //   languages: 'English',
    //   currency: 'USD',
    // }
  }
  Object.entries(newParams).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })
  return url.toString()
}

//赋值到剪切板
export const copyToClipboard = (text: string) => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
  }
  return new Promise<void>((resolve, reject) => {
    const ta = document.createElement('textarea')
    ta.value = text
    ta.style.position = 'fixed'
    ta.style.top = '-9999px'
    ta.style.opacity = '0'
    document.body.appendChild(ta)
    ta.select()
    try {
      const ok = document.execCommand('copy')
      document.body.removeChild(ta)
      ok ? resolve() : reject(new Error('execCommand copy failed'))
    } catch (e) {
      document.body.removeChild(ta)
      reject(e)
    }
  })
}
